import React, { useState } from "react";

const FaqsPage = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: "How often is payroll processed?",
            answer: "Payroll can be processed weekly, bi-weekly, semi-monthly, or monthly, depending on your company’s settings."
        },
        {
            question: "How do I update an employee's salary or hourly wage?",
            answer: "You can update an employee’s wage in the Employee Management section under Payroll Settings."
        },
        {
            question: "Can employees access their pay stubs online?",
            answer: "Yes, employees can log in to their accounts and access pay stubs under the 'Payroll History' section."
        },
        {
            question: "How do I set up direct deposit?",
            answer: "Go to Payroll Settings, enter the employee’s bank details, and enable direct deposit. Processing may take 1-2 business days."
        },
        {
            question: "What should I do if an employee is missing from the payroll run?",
            answer: "Check if the employee is active in the system, confirm their payment schedule, and ensure they have logged hours for the pay period."
        },
        {
            question: "How do I generate tax forms (W-2, 1099)?",
            answer: "Navigate to the 'Tax Documents' section and select the desired form to generate and download."
        },
        {
            question: "What happens if payroll is submitted late?",
            answer: "If payroll is submitted after the deadline, payments may be delayed. Consider using expedited processing if available."
        },
        {
            question: "How do I add a bonus or reimbursement to payroll?",
            answer: "When running payroll, use the ‘Add Earnings’ option to enter bonus or reimbursement amounts."
        },
        {
            question: "Can I cancel a payroll after submission?",
            answer: "Payroll can be canceled before processing starts. If already processed, you may need to issue adjustments in the next payroll cycle."
        }
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div style={styles.container}>
            <h2>Payroll FAQs</h2>

            <div style={styles.faqList}>
                {faqs.map((faq, index) => (
                    <div key={index} style={styles.faqItem}>
                        <div style={styles.question} onClick={() => toggleFAQ(index)}>
                            {faq.question}
                            <span style={styles.icon}>{openIndex === index ? "▼" : "▶"}</span>
                        </div>
                        {openIndex === index && <p style={styles.answer}>{faq.answer}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
};

// Styles
const styles = {
    container: {
        maxWidth: "600px",
        margin: "50px auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        textAlign: "left",
    },
    faqList: {
        marginTop: "20px",
    },
    faqItem: {
        padding: "10px",
        borderBottom: "1px solid #ddd",
        cursor: "pointer",
    },
    question: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#007bff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    answer: {
        marginTop: "5px",
        fontSize: "12px",
        color: "#333",
        fontWeight: "bold",
    },
    icon: {
        marginLeft: "10px",
    },
};

export default FaqsPage;
